import React, { FunctionComponent } from "react";

const ShowHideListButton: FunctionComponent<ShowHideListButtonProps> = ({
  isShown,
  className = "",
  onClick,
}) => {
  return (
    <button
      className={`tw-border tw-rounded-full tw-p-1 tw-px-3 tw-w-max tw-bg-nrma-dark-blue tw-text-white tw-font-button ${className}`}
      onClick={onClick}
    >
      {isShown ? "Hide List" : "Show List"}
    </button>
  );
};

export type ShowHideListButtonProps = {
  className?: string;
  isShown: boolean;
  onClick: VoidFunction;
};

export default React.memo(ShowHideListButton);
